
const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
    },
    wrapper: {
      extend: theme.wrapper,
      display: 'flex',
      justifyContent: 'center',
      paddingTop: 40,
      paddingBottom: 20,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    wrapper: {
      paddingTop: 40,
      paddingBottom: 20,
    },
  }

  return output
}

export default style
